module.exports = __webpack_public_path__ + "afee18f725ffa321f2004304a7f11ace.png";